export default "__VITE_ASSET__BOy8rlHx__"